import isObject from 'lodash/isObject'
import {
  CollectionModel,
  ContentExperimentModel,
  HasTypeName,
  InlineExperimentModel,
  PageModel,
  UltrawideBannerGroupModel,
} from '@/services/RenderService/types'
import {
  AudienceInterest,
  CollectionDisplay,
  CuratedCollection,
  FeaturedProject,
  FranchiseComponent,
} from '@/types/codegen-contentful'

export const CURATED_COLLECTION_DATA_SOURCES = ['sneak-peeks-v2', 'start-watching-v2'] as const

export type CuratedCollectionDataSource = (typeof CURATED_COLLECTION_DATA_SOURCES)[number]

export interface ValidCuratedCollection extends Omit<CuratedCollection, 'dataSource'> {
  dataSource: CuratedCollectionDataSource
}

export function isValidCuratedCollection(content: unknown): content is ValidCuratedCollection {
  return (
    isCuratedCollection(content) &&
    CURATED_COLLECTION_DATA_SOURCES.includes(content.dataSource as CuratedCollectionDataSource)
  )
}

export function isCollectionDisplay(content: unknown): content is CollectionDisplay {
  return isHasTypeName(content) && content.__typename === 'CollectionDisplay'
}

export function isCollectionModel(content: unknown): content is CollectionModel {
  return isHasTypeName(content) && content.__typename === 'Collection'
}

export function isCuratedCollection(content: unknown): content is CuratedCollection {
  return isHasTypeName(content) && content.__typename === 'CuratedCollection'
}

export function isUltrawideBannerGroupModel(content: unknown): content is UltrawideBannerGroupModel {
  return isHasTypeName(content) && content.__typename === 'UltrawideBannerGroup'
}

export function isPageModel(content: unknown): content is PageModel {
  return isHasTypeName(content) && content.__typename === 'Page'
}

export function isContentExperimentModel(content: unknown): content is ContentExperimentModel {
  return isHasTypeName(content) && content.__typename === 'ContentExperiment'
}

export function isInlineExperimentModel(content: unknown): content is InlineExperimentModel {
  return isHasTypeName(content) && content.__typename === 'InlineExperiment'
}

export function isHasTypeName(content: unknown): content is HasTypeName {
  /* eslint-disable no-prototype-builtins */
  return isObject(content) && content.hasOwnProperty('__typename')
}

export function isFeaturedProject(content: unknown): content is FeaturedProject {
  return isHasTypeName(content) && content.__typename === 'FeaturedProject'
}

export function isFranchiseComponent(content: unknown): content is FranchiseComponent {
  return isHasTypeName(content) && content.__typename === 'FranchiseComponent'
}

export function isAudienceInterest(content: unknown): content is AudienceInterest {
  return isHasTypeName(content) && content.__typename === 'AudienceInterest'
}
